import { render } from "./Review.vue?vue&type=template&id=38880e50&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=38880e50&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-38880e50"

export default script